<style scoped>
@import "./newMessage.css";
</style>

<template>
  <Poptip transfer placement="bottom" title="消息通知" trigger="hover" width="300">
    <Badge :dot="isDot">
      <Icon class="category-item-icon" type="ios-mail"></Icon> 消息
    </Badge>
    <div id="message" slot="content">
        <ul>
            <li v-for="(item, index) in lists" :key='index'>
              <a href="">{{item.title}}</a>{{item.time}}
            </li>
        </ul>
        <a class="see-more" href="">查看更多 <Icon type="ios-arrow-down"></Icon></a>
    </div>
  </Poptip>

</template>

<script>
export default {
  name: "newMessage",
  data() {
    return {
      isDot: false,
      lists: [
        { id: 1, title: "这是一条新闻这是一条新闻", time: "2017-02-29" },
        { id: 1, title: "这是一条新闻这是一条新闻", time: "2017-02-29" },
        { id: 1, title: "这是一条新闻这是一条新闻", time: "2017-02-29" },
        { id: 1, title: "这是一条新闻这是一条新闻", time: "2017-02-29" },
        { id: 1, title: "这是一条新闻这是一条新闻", time: "2017-02-29" }
      ]
    };
  },
  methods: {}
};
</script>
